import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const alertApi = createApi({
    reducerPath: "alert",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['Alert'],
    endpoints: (builder) => ({

        getAllAlerts: builder.query({
            query: ({ pageno, search, status, sortOrder, sortBy, limit }) => {
                let url = `/admin/alerts?pageno=${pageno}&search=${search}&status=${status}`;
                if (sortOrder) {
                    url += `&sortOrder=${sortOrder}`;
                }
                if (sortBy) {
                    url += `&sortBy=${sortBy}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ['Alert'],
        }),

        getAlert: builder.query({
            query: (id) => ({
                url: `/admin/alert/${id}`,
                method: "GET",
            }),
            providesTags: ['Alert'],
        }),

        addAlert: builder.mutation({
            query: (data) => ({
                url: `/admin/alert`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['Alert'],
        }),

        editAlert: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/alert/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ['Alert'],
        }),

        deleteAlert: builder.mutation({
            query: (id) => ({
                url: `/admin/alert/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['Alert'],
        }),

    }),
});

export const {
    useGetAllAlertsQuery,
    useGetAlertQuery,
    useAddAlertMutation,
    useEditAlertMutation,
    useDeleteAlertMutation,
} = alertApi;
